var map = {
	"./date-format.de-CH.json": 950,
	"./date-format.de-DE.json": 951,
	"./date-format.en-CA.json": 952,
	"./date-format.en-GB.json": 953,
	"./date-format.en-IN.json": 954,
	"./date-format.en-ME.json": 955,
	"./date-format.en-US.json": 956,
	"./date-format.es-EM.json": 957,
	"./date-format.es-ES.json": 958,
	"./date-format.fr-BE.json": 959,
	"./date-format.fr-CA.json": 960,
	"./date-format.fr-CH.json": 961,
	"./date-format.nl-BE.json": 962,
	"./date-format.nl-NL.json": 963,
	"./date-format.pl-PL.json": 964,
	"./date-format.pt-BR.json": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 949;